var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCtaSection03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5275 60L28.6813 36.2637L20.7692 58.6813L16.1538 56.8681L26.3736 35.2747L10.5495 53.0769L6.92308 49.4506L24.7253 33.6264L3.13187 43.8462L1.31868 39.2308L23.7363 31.3187L0 32.4725V27.5275L23.7363 28.8462L1.31868 20.7692L3.13187 16.3187L24.7253 26.5385L6.92308 10.5494L10.5495 7.08791L26.3736 24.7253L16.1538 3.2967L20.7692 1.31868L28.6813 23.9011L27.5275 0H32.4725L31.1538 23.7363L39.2308 1.31868L43.6813 3.2967L33.4615 24.7253L49.4505 7.08791L52.9121 10.5494L35.2747 26.5385L56.7033 16.3187L58.6813 20.7692L36.0989 28.8462L60 27.5275V32.4725L36.0989 31.3187L58.6813 39.2308L56.7033 43.8462L35.2747 33.6264L52.9121 49.4506L49.4505 53.0769L33.4615 35.2747L43.6813 56.8681L39.2308 58.6813L31.1538 36.2637L32.4725 60H27.5275Z",
    fill: "#EE8F4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtaSection03);
export default __webpack_public_path__ + "static/media/cta_section_03.5766927fc3dd44155985083ce3159e1c.svg";
export { ForwardRef as ReactComponent };